(function($) {

    $(document).ready(function () {

        mobileMenu();
        smoothScroll();
        $('.menu-toggle').click(function() {
            $('#nav').slideToggle();
        });

        qutoes();
        var map = document.getElementById('map-container');
        if (map !== null) {
            gmaps();
        }
        var table = $('table');
        if (table) {
            table.wrap('<div class="table-responsive"></div>');
        }

    });
    $(window).resize(function () {
        mobileMenu();
    });
    function mobileMenu () {
        if (window.matchMedia("(max-width: 869px)").matches) {
            $('.logo').insertBefore('#nav');
        }else{
            $('.logo').insertAfter('.left-menu');
        }
    }
    function smoothScroll() {
        $('a[href*="#"]:not([href="#"]):not(.no-scroll)').click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top - 51
                    }, 1000);
                    return false;
                }
            }
        });
    }
    function qutoes() {
        $('#cytaty .slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
        });
    }

    function gmaps() {
        function initialize() {
            for (var i = 0; i < maps.length; i++) {
                var locked = true;
                var map = new google.maps.Map(document.getElementById(maps[i].container), {
                    center: maps[i].center,
                    zoom: maps[i].zoom,
                    scrollwheel: true,
                    draggable: true
                });
                
                
                new google.maps.Marker({
                    position: new google.maps.LatLng(maps[i].lat, maps[i].lng),
                    map: map
                });
            }
        }

        google.maps.event.addDomListener(window, 'load', initialize);
    }
    function breakpoint() {
        function detect() {
            if ($('.container').length) {
                switch (parseInt(getComputedStyle(document.querySelector('.container')).width)) {
                    case 720:
                        return 'sm';
                    case 750:
                        return 'sm';
                    case 940:
                        return 'md';
                    case 970:
                        return 'md';
                    case 1140:
                        return 'lg';
                    case 1170:
                        return 'lg';
                    default:
                        return 'xs';
                }
            }
        }

        var current = detect();

        if (arguments.length === 0) {
            return current;
        }

        for (var i = 0; i < arguments.length; i++) {
            if (arguments[i] === current) {
                return true;
            }
        }

        return false;
    }
}(jQuery));